@if (menuItems?.length > 0) {
  <p-button class="share-button" #share aria-label="Share finding" variant="text" (click)="menu.toggle($event)" pTooltip="Share finding" tooltipPosition="top">
    @if (sharing) {
      <fa-icon [icon]="faSyncAlt" animation="spin"></fa-icon>
    } @else {
      <fa-icon [icon]="faShareAlt"></fa-icon>
    }
    @if (optText) {
      {{ optText }}
    }
  </p-button>
  <p-tieredMenu appendTo="body" #menu [model]="menuItems" [popup]="true"></p-tieredMenu>
  <p-popover #sharePopover>
    <ng-template pTemplate="header">
      <div class="popover-header">
        <span>Share Finding</span>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="popover-content">
        <div class="share-link-container">
          <input type="text" pInputText class="share-link" [readonly]="true" [ngModel]="shareLink" [ngModelOptions]="{standalone: true}">
          @if (!shareLinkCopied) {
            <fa-icon class="copy-icon clickable" [icon]="faCopy" size="lg" [fixedWidth]="true" pTooltip="Copy to clipboard" tooltipPosition="top" (click)="copyToken()"></fa-icon>
          }
          @if (shareLinkCopied) {
            <fa-icon class="copy-icon" [icon]="faCheck" size="lg" [fixedWidth]="true" pTooltip="Copied!" tooltipPosition="top"></fa-icon>
          }
        </div>
      </div>
    </ng-template>
  </p-popover>
}
